import clsx from 'clsx';
import {FC} from 'react';

type StrokeProps = {
    className?: string;
};

const Stroke: FC<StrokeProps> = ({className}) => (
    <div
        className={clsx(
            className,
            'mr-2 mt-0.5 inline-block h-5 justify-center rounded border-2 border-grey-500 align-middle',
        )}
    />
);

export default Stroke;
